(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxWidgetNavigation', {
		bindings: {},
		controller: MxWidgetNavigationCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-widgets-panel/widgets/mx-widget-navigation.html',
	});

	MxWidgetNavigationCtrl.$inject = [
		'$scope',
		'$window',
		'$timeout',
		'mx.shell.SidePanelService',
		'mx.shell.EventService',
		'mx.shell.NavigationService',
		'mx.SolutionBuilderAgent.WidgetsPanelService',
	];

	function MxWidgetNavigationCtrl($scope, $window, $timeout, sidePanelService, eventService, navigationService, widgetsPanelService) {
		var vm = this;
		vm.sidePanelService = sidePanelService;
		vm.navigationService = navigationService;

		vm.itemClickHandler = itemClickHandler;
		vm.rootItemClickHandler = rootItemClickHandler;
		vm.isItemVisible = isItemVisible;

		eventService.subscribeTo(
			mx.shell.EventCodes.CurrentNavigationItemChanged,
			function (event, data) {
				var needHideWidget =
					data.navigationItem.hideLeftSideNavigation || (!data.navigationItem.parent && (!data.navigationItem.children || !data.navigationItem.children.length));

				if (widgetsPanelService.navigationWidget.visible) {
					if (needHideWidget) {
						widgetsPanelService.hideWidget(widgetsPanelService.navigationWidget);
					} else {
						$timeout(function () {
							setCurrentClasses();
						});
					}
				} else {
					if (!needHideWidget) {
						$timeout(function () {
							setCurrentClasses();
							widgetsPanelService.showWidget(widgetsPanelService.navigationWidget);
						});
					}
				}
			},
			$scope
		);

		vm.$onInit = function () {
			if (navigationService.navItems && navigationService.navItems.length && navigationService.currentItem) {
				$timeout(function () {
					setCurrentClasses();
				});
			}
		};

		return vm;

		function itemClickHandler($event, item) {
			$event.preventDefault();
			$event.stopPropagation();

			if (navigationService.currentItem === item) {
				navigationService.setActiveStatus(navigationService.currentItem, true);
				setCurrentClasses();
				return;
			}

			if (item.route) {
				navigationService.currentItem = item;
			} else {
				navigationService.setActiveStatus(navigationService.currentItem, false);
				navigationService.currentItem.activated = true;
				navigationService.setActiveStatus(item, true);
				setCurrentClasses();
			}
		}

		function rootItemClickHandler($event, item) {
			$event.preventDefault();
			$event.stopPropagation();

			navigationService.setActiveStatus(navigationService.currentItem, false);
			navigationService.currentItem.activated = true;
			item.selected = true;
			item.current = true;

			var visibleIds = item.children
				.map(function (child) {
					return child.id;
				})
				.concat(item.id);

			var items = document.querySelectorAll('.mx-widget-navigation--item');
			items.forEach(function (DOMItem) {
				if (DOMItem.classList.contains('visible') + (visibleIds.indexOf(DOMItem.id) >= 0) === 1) {
					//XOR
					DOMItem.classList.toggle('visible');
				}

				if (DOMItem.classList.contains('selected') + (DOMItem.id === item.id) === 1) {
					DOMItem.classList.toggle('selected');
				}
			});
		}

		function isItemVisible(item) {
			var currentItem = navigationService.currentItem || {};
			return Boolean(
				item.current ||
					(item.parent &&
						(item.parent === currentItem ||
							(item.parent === currentItem.parent && (currentItem.hasChildren === false || (currentItem.children && currentItem.children.length === 0)))))
			);
		}

		function setCurrentClasses() {
			var navDOMItems = document.querySelectorAll('.mx-widget-navigation--item');
			navigationService.getFlatArrayOfNavItems().then(function (navItems) {
				navDOMItems.forEach(function (item) {
					var navItem = _.find(navItems, { id: item.id });
					if (navItem) {
						toggleClasses(navItem, item);
					}
				});
			});
		}

		function toggleClasses(navItem, navDOMItem) {
			if (!navItem || !navDOMItem) {
				return;
			}
			if (navDOMItem.classList.contains('activated') + navItem.activated === 1) {
				// XOR
				navDOMItem.classList.toggle('activated');
			}

			if (navDOMItem.classList.contains('current') + navItem.current === 1) {
				// XOR
				navDOMItem.classList.toggle('current');
			}

			if (navDOMItem.classList.contains('visible') + isItemVisible(navItem) === 1) {
				// XOR
				navDOMItem.classList.toggle('visible');
			}

			if (navDOMItem.classList.contains('parent-of-activated') + navItem.parentOfActivated === 1) {
				// XOR
				navDOMItem.classList.toggle('parent-of-activated');
			}

			if (navDOMItem.classList.contains('selected') + Boolean(!navItem.parent && navItem.activated) === 1) {
				//XOR
				navDOMItem.classList.toggle('selected');
			}
		}
	}
})();
